import { render } from "./setModulePrice.vue?vue&type=template&id=1c7c9982&scoped=true"
import script from "./setModulePrice.vue?vue&type=script&lang=js"
export * from "./setModulePrice.vue?vue&type=script&lang=js"

import "./setModulePrice.vue?vue&type=style&index=0&id=1c7c9982&scoped=true&lang=css"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7c9982"]])

export default __exports__